import { atom } from "recoil";

export const isMakeRoomShowAtom = atom<any>({
  key: "isMakeRoomShowAtom",
  default: false,
});
